import { LoanDataModel } from '../../cmg-1003/models/loan-information.model';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from './loan-status-card.model';
import moment from 'moment';
import { LoanItemStatus, LoanItemStatusIconType } from '../../shared/models';

export const GetPricingStatus = (loanInfo: LoanDataModel): ILoanStatusCard => {
  const cardBase = LoanStatusCardConfig.find((c) => c.cardType === LoanStatusCardType.Pricing);
  const card = <ILoanStatusCard>{ ...cardBase, cardType: LoanStatusCardType.Pricing };
  const timePricedDate = moment(loanInfo?.timePriced);
  const lockExpirationDate = moment(loanInfo?.lockExpirationDate);
  const daysToExpiration = lockExpirationDate ? moment(lockExpirationDate).endOf('day').diff(moment.now(), 'days') : null;

  // No Pricing:
  if (!loanInfo?.pricedProductName?.trim()) {
    card.status = LoanItemStatus.NotComplete;
    card.icon = LoanItemStatusIconType.UnLock;
    card.descriptionHtml = `Not Complete`;
  }

  // Pricing with No Lock Expiration Date:
  if (loanInfo?.pricedProductName?.trim() && !loanInfo?.lockExpirationDate) {
    card.status = LoanItemStatus.NotComplete;
    card.icon = LoanItemStatusIconType.UnLock;
    card.descriptionHtml = `Floating Priced <b>${timePricedDate.format('M/D/YY')}</b>`;
  }

  // Pricing Complete with Lock Expiration Countdown:
  // No check against pricedProductName here as the loan can be locked in Byte and pricedProductName will be undefined in this case.
  if (loanInfo?.lockExpirationDate) {
    if (daysToExpiration > 5) {
      card.status = LoanItemStatus.Complete;
      card.icon = LoanItemStatusIconType.Lock;
      card.descriptionHtml = `Lock Exp. <b>${lockExpirationDate.format('M/D/YY')}</b>`;
    } else if (daysToExpiration > 0 && daysToExpiration <= 5) {
      card.status = LoanItemStatus.Warning;
      card.icon = LoanItemStatusIconType.Lock;
      card.descriptionHtml = `Lock Exp. <b>${lockExpirationDate.format('M/D/YY')}</b> <br> Lock Exp. in <b>${daysToExpiration}</b> days`;
    } else if (daysToExpiration <= 0) {
      card.status = LoanItemStatus.Error;
      card.icon = LoanItemStatusIconType.UnLock;
      card.descriptionHtml = `Lock Expired <b>${lockExpirationDate.format('M/D/YY')}</b>`;
    }
  }

  return card;
};
